<template>
  <div>
    <v-row class="form-title" align="center" justify="center"
      ><h2 v-if="!generalFailure">
        Grazie per aver scelto Aki Digital Solutions.
      </h2>
      <h2 v-if="!generalFailure && !emailsCreated">
        Stiamo configurando il suo nuovo sito Internet, le chiediamo di
        attendere ancora qualche minuto...
      </h2>

      <h3 class="red--text" v-if="generalFailure">
        {{ generalFailure }}
      </h3></v-row
    >
    <v-row class="form-title" align="center" justify="center">
      <ul v-if="!generalFailure">
        <li>
          <v-progress-circular
            v-if="domainConsolidating"
            :indeterminate="true"
            :rotate="0"
            :size="28"
            :width="3"
            color="light-blue"
          />
          <v-icon v-if="domainConsolidated" color="green" size="32"
            >mdi-check-circle-outline</v-icon
          >
          <v-icon
            v-if="!domainConsolidating && !domainConsolidated"
            color="secondary"
            size="32"
            >mdi-pause-circle-outline</v-icon
          >
          Attivazione e costruzione del sito in corso...
        </li>
        <li v-if="$store.state.wizard.meta.transaction != 'wire-transfer'">
          <v-progress-circular
            v-if="domainRegistering"
            :indeterminate="true"
            :rotate="0"
            :size="28"
            :width="3"
            color="light-blue"
          />
          <v-icon v-if="domainRegistered" color="green" size="32"
            >mdi-check-circle-outline</v-icon
          >
          <v-icon
            v-if="!domainRegistering && !domainRegistered"
            color="secondary"
            size="32"
            >mdi-pause-circle-outline</v-icon
          >
          Registrazione dominio {{ fullDomainName }} nei registri
          internazionali...
        </li>
      </ul>
    </v-row>
    <v-row class="form-title" align="center" justify="center"
      ><h4
        v-if="
          emailsCreated &&
            $store.state.wizard.meta.transaction != 'wire-transfer'
        "
      >
        La configurazione del suo nuovo sito è completata. Le ricordiamo che la
        registrazione del dominio può richiedere da un minimo di 60 minuti ad un
        massimo di 48 ore. Durante questo periodo temporale il suo nuovo sito
        non sarà ancora visibile ma potrà comunque modificarlo attraverso la sua
        area privata dove potrà anche visualizzarlo in anteprima utilizzando
        l'apposita funzione. La ringraziamo per aver scelto i nostri servizi!
      </h4>

      <h4
        v-if="
          emailsCreated &&
            $store.state.wizard.meta.transaction == 'wire-transfer'
        "
      >
        La configurazione del suo nuovo sito è completata sui nostri sistemi.
        Non appena riceveremo il suo bonifico le invieremo una mail di conferma
        e registreremo il suo dominio. Nel frattempo può accedere alla sua area
        privata per controllare lo stato e continuare ad apportare delle
        modifiche.
      </h4>
    </v-row>

    <v-row
      v-if="emailsCreated"
      class="form-title"
      align="center"
      justify="center"
    >
      <v-btn dark @click="goToDashboard()" color="#b083a8" class="white--text ml-2"
        >VAI ALLA TUA AREA PRIVATA</v-btn
      >
    </v-row>
  </div>
</template>

<script>
import domains from "../../apis/domains";

export default {
  data() {
    return {
      domainConsolidating: false,
      domainRegistering: false,
      domainCreating: false,
      emailsCreating: false,
      domainConsolidated: false,
      domainRegistered: false,
      domainCreated: false,
      emailsCreated: false,
      zoneConfigured: false,
      generalFailure: null,
      build_id: null,
      site_id: null,
      fullDomainName: null,
    };
  },

  mounted() {
    this.$emit("paymentCompleted");
    let domainName = this.$store.state.wizard.meta
      ? this.$store.state.wizard.meta.domain
      : null;
    let domainExtension = this.$store.state.wizard.meta
      ? this.$store.state.wizard.meta.domainExtension
      : null;
    this.build_id = this.$store.state.wizard.build_state_id;
    this.fullDomainName = domainName + domainExtension;

    if (this.$store.state.wizard.completed) {
      this.emailsCreated = this.domainConsolidated = this.domainRegistered = this.domainCreated = this.zoneConfigured = true;
      return;
    }

    this.domainConsolidating = true;

    domains
      .consolidateDomain(this.build_id)
      .then((res) => {
        if (res.err) this.generalFailure = res.err;
        else {
          this.domainConsolidating = false;
          this.domainConsolidated = true;
          this.site_id = res;

          if (this.$store.state.wizard.meta.transaction != "wire-transfer") {
            this.domainRegistering = true;

            domains
              .registerDomain(this.site_id,this.$store.state.user.id)
              .then((res) => {
                if (res.err) this.generalFailure = res.err;
                else {
                  this.domainRegistering = false;
                  this.domainRegistered = true;
                  this.$store
                    .dispatch("completeWizard", { site_id : this.site_id, operation_id : res.OperationId})
                    .then(() => {
                      this.emailsCreated = true;
                    });
                }
              })
              .catch((err) => {
                this.generalFailure = err;
              });
          } else {
            this.$store.dispatch("completeWizard",{ site_id : this.site_id}).then(() => {
              this.emailsCreated = true;
            });
          }
        }
      })
      .catch((err) => {
        this.generalFailure = err;
      });
  },

  methods: {
    goToDashboard() {
      this.$store.dispatch("wipeWizard").then(() => {
        this.$router.push("/");
      });
    },
  },
};
</script>

<style scoped>
.form-title {
  color: gray;
  font-size: 20px;
  margin: 10px;
}

.form-title-sub {
  color: gray;
  font-size: 16px;
  margin: 10px;
}

.form-title-sub-mini {
  color: gray;
  font-size: 14px;
  margin: 10px;
}

.form-content {
}

.form-spacer {
  height: 30px;
}

ul {
  list-style-type: none;
}

li {
  text-align: left;
  margin: 5px;
  padding: 5px;
}
</style>
